<template>
  <el-dialog :title="form.id ? '编辑资源' : '新增资源'" :visible.sync="_dialogVisible" :close-on-click-modal="false">
    <el-form :model="form" ref="listForm">
      <template>
        <el-form-item label="菜单名称：" label-width="120px" prop="resourcesName" :rules="[{ required: true, message: '请输入菜单名称', trigger: 'blur' }]">
          <el-input v-model="form.resourcesName" placeholder="请输入菜单名称" :maxlength="30"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="上级资源：" label-width="120px">
        <el-popover placement="bottom-start" width="300" trigger="click">
          <el-tree :data="resourceList" :props="resourceProps" @node-click="parentResourceClick" :expand-on-click-node="false" default-expand-all class="tree-wrapper"></el-tree>
          <el-input v-model="selectedParentResource.parentName" slot="reference" readonly @focus="parentResourceFocus"></el-input>
        </el-popover>
      </el-form-item>
      <el-form-item prop="url" label="资源路由：" label-width="120px" :rules="[{ required: true, message: '资源路由不能为空', trigger: 'blur' }]">
        <div class="tip-icon-wrapper">
          <el-input v-model="form.url" placeholder="请选择资源路由"></el-input>
          <el-tooltip effect="light" placement="top-start">
            <div slot="content" class="content">
              URL格式：
              <br />1.常规业务开发的功能URL，如用户管理，views目录下页面路径为 /Sys/User, 此处填写 /sys/user。 <br />2.嵌套外部网页，如通过菜单打开百度网页，此处填写 http://www.baidu.com，http://
              不可省略。 <br />示例：用户管理：/sys/user 嵌套百度：http://www.baidu.com 嵌套网页：http://127.0.0.1:8000
              <br />
            </div>
            <el-icon class="icon el-icon-warning"></el-icon>
          </el-tooltip>
        </div>
      </el-form-item>
      <el-form-item prop="resourcesCode" label="资源code：" label-width="120px" :rules="[{ required: true, message: '资源code不能为空', trigger: 'blur' }]">
        <el-input v-model="form.resourcesCode" placeholder="如：sys:user:add,sys:user:edit" :maxlength="24"></el-input>
      </el-form-item>
      <template>
        <el-form-item label="排序编号：" label-width="120px">
          <el-input-number v-model="form.sort" controls-position="right" :min="0" :max="120"></el-input-number>
        </el-form-item>
        <el-form-item label="备注：" label-width="120px">
          <el-input type="textarea" :rows="2" :maxlength="200" placeholder="请输入备注" v-model="form.remark"></el-input>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
const topResource = {
  id: "",
  resourcesName: "顶级路由",
  children: [],
};
const defaultFormData = {
  resourcesName: "",
  parentId: "",
  resourcesCode: "",
  url: "",
  sort: 0,
  icon: "",
  remark: "",
};

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    parentResource: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
    resourceProps() {
      return { children: "children", label: "resourcesName" };
    },
  },
  watch: {
    _dialogVisible(val) {
      if (val) {
        if (this.id) {
          this.loadResourcesDetail();
        } else {
          this.form = Object.assign({}, defaultFormData);
          this.selectedParentResource = {
            parentId: "",
            parentName: "顶级路由",
          };
          if (this.parentResource.parentId) {
            this.selectedParentResource = this.parentResource;
            this.form.parentId = this.parentResource.parentId;
          }
        }
      }
    },
  },
  data() {
    return {
      btnLoading: false,
      form: Object.assign({}, defaultFormData),
      resourceList: [],
      selectedParentResource: {
        parentId: "",
        parentName: "顶级路由",
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.listForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          const params = Object.assign({}, this.form, this.selectedParentResource);

          this.$http({
            url: this.form.id ? global.apiUrl + "/resources/menuEdit" : global.apiUrl + "/resources/addMenu",
            method: this.form.id ? "PUT" : "POST",
            body: params,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this._dialogVisible = false;
                this.$emit("onSuccess");
              } else {
              }
              setTimeout(() => {
                this.btnLoading = false;
              }, 500);
            })
            .catch(err => {
              this.btnLoading = false;

              console.error(err);
            });
        }
      });
    },
    parentResourceClick(item) {
      this.selectedParentResource = {
        parentId: item.id,
        parentName: item.resourcesName,
      };
    },
    parentResourceFocus() {
      this.$http({
        url: global.apiUrl + "/resources/findMenuTree",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const _topResource = Object.assign({}, topResource);
              _topResource.children = res.body.data;
              this.resourceList = [_topResource];
            } else {
              this.resourceList = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    loadResourcesDetail() {
      this.$http({
        url: global.apiUrl + `/resources/menuDetail/${this.id}`,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.form = res.body.data;

              const { parentId, parentName } = this.form;
              this.selectedParentResource = {
                parentId: parentId,
                parentName: parentName,
              };
            } else {
              this.form = {};
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.tip-icon-wrapper {
  display: flex;
  align-items: center;
  .content {
  }
  .icon {
    font-size: 20px;
    margin-left: 12px;
  }
}
.tree-wrapper {
  max-height: 300px;
  overflow: auto;
}
</style>
